import { api } from './client';

export interface ProfileEmployee {
  id: string;
  employeeNumber: string | null;
  fullName: string;
  email: string | null;
  phoneNumber: string | null;
  dateOfBirth: string | null;
  gender: string | null;
  employmentType: string | null;
  employmentStatus: string | null;
  joiningDate: string | null;
  confirmationDate: string | null;
  department: { id: string; name: string } | null;
  position: { id: string; name: string } | null;
  manager: { id: string; fullName: string } | null;
  companyEntity: { id: string; name: string } | null;
  workSite: { id: string; name: string } | null;
}

export interface ProfileResponse {
  user: { id: string; email: string; role: string; employeeId?: string };
  employee: ProfileEmployee | null;
}

export function getProfile() {
  return api<ProfileResponse>('/profile');
}
